import { helpers } from '@vuelidate/validators';
import type { AuthAuthIsEmailBusyRouteRpc } from '@repo/contract';
import { fetchRpc } from '../../transport/fetch-rpc';

export const emailBusyRule = helpers.withMessage(
  'Email is busy',
  helpers.withAsync(
    async (email: string) => {
      const { isBusy } = await fetchRpc<typeof AuthAuthIsEmailBusyRouteRpc>(
        '/api/rpc/auth/auth/is-email-busy',
        { email },
      );

      return !isBusy;
    },
  ),
);
